import Image from "next/image";
import React, { useMemo } from "react";

import { IBynderImage } from "@brexhq/shared/types/BynderAsset";
import isChromatic from "@brexhq/shared/utils/env/isChromatic";
import { isStorybook } from "@brexhq/shared/utils/env/isStorybook";
interface NextImageProps {
  image: IBynderImage;
  width?: number;
  altTextOverride?: string;
  className?: string;
  loading?: "eager" | "lazy";
  priority?: boolean;
  responsiveLayout?: boolean;
}

export const NextImage: React.FC<NextImageProps> = ({
  image,
  width = 2000,
  altTextOverride,
  className,
  loading,
  priority,
  responsiveLayout,
}) => {
  const loadingProps = useMemo(() => {
    if (priority) {
      return { priority: true };
    }
    return { loading: loading ?? "lazy" };
  }, [priority, loading]);
  if (!image) return null;

  const height = Math.max(Math.round(width * image.aspectRatio), 3);
  const altText = altTextOverride ?? image.description ?? image.name;
  const isStory = isStorybook();

  return (
    <Image
      data-testid="next-image"
      className={className}
      src={image.datUrl ?? image.previewImg}
      width={width}
      height={height}
      alt={altText ?? ""}
      color="transparent"
      unoptimized={isStory}
      quality={100}
      data-chromatic={isChromatic() ? "ignore" : undefined}
      sizes={`(max-width: ${width}px) 100vw, ${width}px`}
      {...loadingProps}
      style={responsiveLayout ? { width: "100%", height: "auto" } : undefined}
    />
  );
};
